import { IconChevronDown } from "@pentabd/icons";
import { Button, Select, Text } from "@pentabd/ui";
import { useTranslation } from "react-i18next";

export default function EmployeeForm() {
  const { t } = useTranslation();
  return (
    <div className="bg-light rounded p-10">
      <div className="row m-0 p-0 gap-6">
        <div className="row m-0 p-0 grow-1">
          <div className="col-6 col-lg-4 ps-0">
            <Text
              color="#344054"
              component="p"
              size="md"
              weight="semibold"
              className="mb-3"
            >
              {t(
                "INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_FORM.FIELDS.FIELD_1.NAME",
              )}
            </Text>
            <Select
              //   {...register(GENERAL_INFO.RELIGION)}
              options={[
                {
                  label: "label 1",
                  value: "label 1",
                },
              ]}
              defaultValue={"test"}
              name="office"
              onSelectItem={(e) => console.log(e)}
              suffix={<IconChevronDown size="16" />}
              placeholder={t(
                "INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_FORM.FIELDS.FIELD_1.PLACEHOLDER",
              )}
            />
            {/* <SelectController
            control={control}
            name={GENERAL_INFO.BLOOD_GROUP}
            register={{ ...register(GENERAL_INFO.BLOOD_GROUP) }}
            options={getConvertedMasterData(bloodGroup, language)}
            setValue={setValue}
          /> */}
          </div>
          <div className="col-6 col-lg-4 ps-0">
            <Text
              color="#344054"
              component="p"
              size="md"
              weight="semibold"
              className="mb-3"
            >
              {t(
                "INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_FORM.FIELDS.FIELD_2.NAME",
              )}
            </Text>
            <Select
              //   {...register(GENERAL_INFO.RELIGION)}
              options={[
                {
                  label: "label 1",
                  value: "label 1",
                },
              ]}
              defaultValue={"test"}
              name="wing"
              onSelectItem={(e) => console.log(e)}
              suffix={<IconChevronDown size="16" />}
              placeholder={t(
                "INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_FORM.FIELDS.FIELD_2.PLACEHOLDER",
              )}
            />
          </div>
          <div className="col-6 col-lg-4 px-0">
            <Text
              color="#344054"
              component="p"
              size="md"
              weight="semibold"
              className="mb-3"
            >
              {t(
                "INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_FORM.FIELDS.FIELD_3.NAME",
              )}
            </Text>
            <Select
              //   {...register(GENERAL_INFO.RELIGION)}
              options={[
                {
                  label: "label 1",
                  value: "label 1",
                },
              ]}
              defaultValue={"test"}
              name="department"
              onSelectItem={(e) => console.log(e)}
              suffix={<IconChevronDown size="16" />}
              placeholder={t(
                "INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_FORM.FIELDS.FIELD_3.PLACEHOLDER",
              )}
            />
          </div>
        </div>

        <div className=" align-self-end">
          <Button
            fill="fill"
            onClick={(e) => console.log(e, "Add Button Clicked")}
            size="md"
            type="info"
            isPadding={false}
            className="px-20 py-5"
          >
            {t(
              "INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_FORM.SEARCH_BUTTON.BUTTON_TEXT",
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
